import React, { useState } from "react";
import { Table } from "react-bootstrap";
import SplitPane from "react-split-pane";
import Pagination from "../../../ETMF/Pagination/Pagination";
import { SpinerDataLoader } from "../../../NoDataFoundTable/NoDataFoundTable";

const EActivity = ({ onMouseDown, tableRef }) => {
  const [loader, setLoadeer] = useState("");
  const data = Array.from({ length: 15 }, (v, i) => ({
    sr: i + 1,
    status: i % 2 === 0 ? "Completed" : "Pending",
    category: `Category ${(i % 3) + 1}`,
    type: `Type ${(i % 4) + 1}`,
    activities: `Activity ${i + 1}`,
    activityBy: `User ${i + 1}`,
    activityDateTime: new Date().toLocaleString(),
  }));

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = data?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(data?.length / itemsPerPage);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={20}
        defaultSize="100%"
        style={{ height: "91%" }}
      >
        {loader ? (
          <SpinerDataLoader />
        ) : (
          <div className="table-container tableLibrarySection">
            <Table
              id="resizable-table"
              striped
              hover
              ref={tableRef}
              className="m-0 custom-table"
            >
              <thead className="thead-sticky top-0">
                <tr>
                  <th style={{ width: 45 }} onMouseDown={(e) => onMouseDown(e, 0)}>Sr.</th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Category</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Type</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Activities</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Activity By</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Activity Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {result?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.sr}</td>
                    <td>{item.status}</td>
                    <td>{item.category}</td>
                    <td>{item.type}</td>
                    <td>{item.activities}</td>
                    <td>{item.activityBy}</td>
                    <td>{item.activityDateTime}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={data?.length}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        )}
      </SplitPane>
    </>
  );
};

export default EActivity;
